import { render, staticRenderFns } from "./siderbarItem.vue?vue&type=template&id=16c2c076&scoped=true"
import script from "./siderbarItem.vue?vue&type=script&lang=js"
export * from "./siderbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2c076",
  null
  
)

export default component.exports